import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-emptysate',
  templateUrl: './emptysate.component.html',
  styleUrls: ['./emptysate.component.css']
})
export class EmptysateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
